/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form } from 'antd';
import { SimulateEntity } from 'domain/entities/SimulateEntity';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { CONSTANTS } from 'utilities/constants/SIMULATE';
import InputAllowNumber from './Input';

const FormSimulateSale = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [btnDisable, setBtnDisable] = React.useState<boolean>(true);

    const replace = (value: string) => {
        return value.replaceAll(',', '');
    };

    const onChangeForm = () => {
        form.validateFields({
            validateOnly: true,
        })
            .then(() => {
                setBtnDisable(false);
            })
            .catch(() => {
                setBtnDisable(true);
            });
    };

    const onSubmit = async (values: any) => {
        const payload: SimulateEntity = {
            loanInterestRate: Number(replace(values?.loanInterestRate)),
            loanPeriod: Number(replace(values?.loanPeriod)),
            loanPaybable: Number(replace(values?.loanPaybable)),
            currentHoldingPeriod: Number(replace(values?.currentHoldingPeriod)),
            personalFunds: Number(replace(values?.personalFunds)),
            rent: Number(replace(values?.rent)),
            managementFee: Number(replace(values?.managementFee)),
            expectedSalePrice: Number(replace(values?.expectedSalePrice)),
        };

        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_010_02}`, { state: payload });
    };

    const itemRules = {
        loanInterestRate: [
            {
                required: true,
                message: getMessage('In_Required', '借入金利'),
            },
        ],
        loanPeriod: [
            {
                required: true,
                message: getMessage('In_Required', '借入期間'),
            },
        ],
        loanPaybable: [
            {
                required: true,
                message: getMessage('In_Required', '借入額'),
            },
        ],
        currentHoldingPeriod: [
            {
                required: true,
                message: getMessage('In_Required', '現在の所有年数'),
            },
        ],
        personalFunds: [
            {
                required: true,
                message: getMessage('In_Required', '自己資金'),
            },
        ],
        rent: [
            {
                required: true,
                message: getMessage('In_Required', '家賃・共益費・管理費など'),
            },
        ],
        managementFee: [
            {
                required: true,
                message: getMessage('In_Required', '管理費・修繕積立金・その他費用など'),
            },
        ],
        expectedSalePrice: [
            {
                required: true,
                message: getMessage('In_Required', '売却予定価格'),
            },
        ],
    };

    return (
        <div className="section-wrapper">
            <div className="simulate-form">
                <Form name="simulate" form={form} onFinish={onSubmit} onChange={onChangeForm}>
                    <div className="simulate-form-item">
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                placeholder={PLACEHOLDER.LOAN_INTEREST_RATE}
                                suffix={'%'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                }}
                                maxLength={4}
                                name="loanInterestRate"
                                fraction={true}
                                rules={itemRules['loanInterestRate']}
                                min={'0.00'}
                                max={99.99}
                                label="借入金利"
                            />
                        </div>
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                placeholder={PLACEHOLDER.LOAN_PERIOD}
                                suffix={'年'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                }}
                                name="loanPeriod"
                                maxLength={4}
                                min={0}
                                max={99}
                                fraction={false}
                                rules={itemRules['loanPeriod']}
                                label="借入期間"
                            />
                        </div>
                    </div>
                    <div className="simulate-form-item">
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                placeholder={PLACEHOLDER.LOAN_PAYBABLE}
                                suffix={'円'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                }}
                                name="loanPaybable"
                                maxLength={9}
                                min={0}
                                max={999990000}
                                label="借入額"
                                rules={itemRules['loanPaybable']}
                                fraction={false}
                            />
                        </div>
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                placeholder={PLACEHOLDER.CURRENT_HOLDING_PERIOD}
                                suffix={'年'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                }}
                                name="currentHoldingPeriod"
                                maxLength={4}
                                min={0}
                                max={99}
                                fraction={false}
                                rules={itemRules['currentHoldingPeriod']}
                                label="現在の所有年数"
                            />
                        </div>
                    </div>
                    <div className="simulate-form-item">
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                placeholder={PLACEHOLDER.PERSONAL_FUNDS}
                                suffix={'円'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                }}
                                name="personalFunds"
                                maxLength={9}
                                fraction={false}
                                min={0}
                                max={999990000}
                                rules={itemRules['personalFunds']}
                                label="自己資金"
                            />
                        </div>
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                placeholder={PLACEHOLDER.RENT}
                                suffix={'円'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                }}
                                name="rent"
                                maxLength={7}
                                min={1}
                                fraction={false}
                                rules={itemRules['rent']}
                                label="家賃・共益費・管理費など（収入）"
                            />
                        </div>
                    </div>
                    <div className="simulate-form-item">
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                placeholder={PLACEHOLDER.MANAGEMENT_FEE}
                                suffix={'円'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                }}
                                name="managementFee"
                                maxLength={7}
                                min={1}
                                fraction={false}
                                rules={itemRules['managementFee']}
                                label="管理費・修繕積立金・その他費用など（支出）"
                            />
                        </div>
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                placeholder={PLACEHOLDER.EXPECTED_SALE_PRICE}
                                suffix={'円'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                }}
                                name="expectedSalePrice"
                                maxLength={10}
                                min={0}
                                fraction={false}
                                rules={itemRules['expectedSalePrice']}
                                label="売却予定価格"
                            />
                        </div>
                    </div>
                    <div className="simulate-form-item">
                        <div
                            className="simulate-form-button"
                            style={{
                                cursor: `${btnDisable ? 'not-allowed' : 'pointer'}`,
                                background: `${btnDisable ? '#D0D3D8' : '#4bcae5'}`,
                            }}
                            onClick={() => (!btnDisable ? form.submit() : null)}
                        >
                            実行
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default FormSimulateSale;
